<template>
	<div>
		<a-modal v-show='!ishand' id='warp_sim3' width='40rem' v-model="visible" on-ok="handleOk1"
			v-dragModal
			:dialog-style="{ top: '20vh' }"
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div  v-html='"狀&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;態"'
					style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 38rem;margin: 1rem 1rem 0 1rem;text-align: center;">
				</div>
			</div>
			<div solt='title' style="position: relative;">
			</div>
			<div style="width: 38rem;" class='body_lis'>
				<div style="padding-top: 1.1rem;position: relative;">
                    <div class="state_div">
                        <div class="state_div_content" :style="{paddingTop:index == 0 ?'0':'' ,border:index == result.length-1 ?'none':''}"  v-for="(item,index) in result" :key="index">
                            <div style="display: flex;align-items: center;">
                                <div v-if="item.realname"> {{ item.position }}{{ item.realname }} ：{{item.review_nodes}}，{{item.remark}}</div>
                                <div style="margin-left: auto;">{{item.create_time}}</div>
                            </div>
                            <!-- <div style="margin-top: 0.5rem;" v-if="item.approval_remark">{{item.approval_remark}}</div> -->
                        </div>
                    </div>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['param'],
		data() {
			return {
				ipoAdmin3: this.$store.state.rolesdata.indexOf('ipoAdmin3') >= 0,
				ishand: false,
				visible: true,
				result:[]


			
			}
		},
		mounted() {
				this.getdata()
		},
		methods: {
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			getdata() {
				this.$ajax({
                    method: 'post',
                    url: this.$api.getFundBuyStatus,
                    data: {
                        // type:this.param.type,
                        id:this.param.id,
                        account:this.param.account,
						fund_code:this.param.fund_code,
						order_code:this.param.order_code,
                }
                }).then(res => {
                    if (res.data.qmiscode === 1000) {
						this.result = res.data.records
                    } else {
                        this.$message.warning(res.data.qmismsg)
                    }
                })

			},
		
			handleOk1() {

			}
		}
	}
</script>

<style lang="scss">
    .state_div{
        background: #f5f5f5;
        padding: 1rem;
        font-size: 0.8rem;
        height: 25rem;
		overflow-y: auto;


    }
    .state_div_content{
        border-bottom: 1px solid #d9d9d9;
        padding: 0.8rem 0;
    }
	
	#warp_sim3 .ant-modal-header,
	#warp_sim3 .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	#warp_sim3 {
		
		.tableBzViewBtnView{text-align: center;}
		.tableBzViewBtn {
			margin: 0 3rem !important;
			color: #fff;
		}
		.ant-form-explain{
			display: none;
		}

		.ant-col-12 {
			text-align: right;
		}

		.ant-form-item-label {
			width: 30%;
		}
		.ant-form-item, .ant-form-item-control{
			width: 100%;
			.ant-calendar-picker{
				width: 100%;
			}
			
		}
		
		.ant-form-item-control-wrapper{
			width:70%;
			.ant-form-item-control{
				width: 100%;
			}
		}
		#lastname{
			.ant-form-item-label{
				width: 15%;
			}
			.ant-form-item-control-wrapper{
				width: 85%;
				textarea{
					width: 100%;
				}
			}
		}
		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}

		.warp-right {
			text-align: right;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
		}

		.ant-input {
			font-size: .8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
		}

		.mydivs {
			overflow-y: auto;
			// margin-bottom: 1rem;
			padding: 1rem;
			margin-left: 4%;
			width: 96%;
			background-color: #f5f5f5;
			margin-bottom: 1rem;
		
			.c {
				font-size: .8rem;
				margin: .2rem 0;
				display: flex;
				justify-content: space-between;
			}
		
			.t {
				margin: .5rem 0;
				border-bottom: 1px solid #d9d9d9;
			}
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #999999;
		}
	}
</style>
